import axios from 'axios';
import { StatusCodes as HTTP } from 'http-status-codes';

export const state = () => ({
    currentUser: getSavedState('auth.currentUser') || {}
});

export const getters = {
    loggedIn: state => !!state.currentUser.id,
    loggedUser: state => state.currentUser,
    isHeadAdmin: (state, getters, rootState, rootGetters) => {
        const { loggedUser } = getters;
        const roleHeadAdmin = rootGetters['roles/HEAD_ADMIN'];

        if (loggedUser.roles) {
            return loggedUser.roles.some(
                role => role.name === roleHeadAdmin.value
            );
        }

        return false;
    }
};

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue;

        saveState('auth.currentUser', newValue);
        setCLUID(state.currentUser.id);
    }
};

export const actions = {
    init({ dispatch }) {
        dispatch('validate');
    },

    async sendOTP(vuexContext, { phone, token }) {
        await axios.$post('/auth/otp', {
            phone,
            _token: token
        });
    },

    async login({ commit, dispatch, getters }, { phone, otp, token }) {
        if (getters.loggedIn) {
            return dispatch('validate');
        }

        const user = await axios.$post('/auth/login', {
            phone,
            otp,
            _token: token
        });

        if (user) {
            commit('SET_CURRENT_USER', user);
        }

        return null;
    },

    async logout({ dispatch }) {
        await axios.post('/auth/logout');
        dispatch('validate');
    },

    async validate({ commit, state }) {
        const { id } = state.currentUser;

        if (!id) {
            return null;
        }

        try {
            setCLUID(id);

            const user = await axios.$get('/auth/me');

            commit('SET_CURRENT_USER', user);

            return user;
        } catch (error) {
            if (error.response && error.response.status === HTTP.UNAUTHORIZED) {
                commit('SET_CURRENT_USER', {});
            }

            return null;
        }
    },

    async updateProfile({ commit }, data) {
        const user = await axios.$post('/auth/profile', data);

        commit('SET_CURRENT_USER', user);

        return user;
    },

    updatePassword(vuexContext, passwords) {
        return axios.$post('/auth/password', passwords);
    }
};

// ===
// Private helpers
// ===

function getSavedState(key) {
    return JSON.parse(window.localStorage.getItem(key));
}

function saveState(key, state) {
    window.localStorage.setItem(key, JSON.stringify(state));
}

function setCLUID(id) {
    axios.defaults.headers.cluid = id || '';
}
